import { render, staticRenderFns } from "./QuestionnaireRespondentTable.vue?vue&type=template&id=23dc4254&"
import script from "./QuestionnaireRespondentTable.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireRespondentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports